import { useEffect, useState } from 'react';
import { showErrorAlert } from '@mews/framework';
import { usePrivilege } from '@mews-commander/core';
import { NewReservationInfo } from '../../newReservation/components/NewReservationPanel/types';
import { useOverbookingMessage } from '../../newReservation/components/NewReservationPanel/utils/useOverbookingMessage';
import { Props as CanvasProps } from '../containers/Canvas';

export const useTimelineBlockOverbookingErrorCheck = ({
    serviceId,
    handleConfirmNewReservation,
    handleCloseNewReservationPanel,
}: CanvasProps) => {
    const canOverbook = usePrivilege('overbookServices');
    const [newReservationInfo, setNewReservationInfo] = useState<NewReservationInfo | null>(null);

    const { overbookingMessage, loading } = useOverbookingMessage(
        serviceId,
        newReservationInfo?.startUtc,
        newReservationInfo?.endUtc,
        newReservationInfo?.resourceCategoryId
    );

    useEffect(() => {
        if (loading || !newReservationInfo) {
            return;
        }
        if (!canOverbook && overbookingMessage) {
            showErrorAlert({ description: <>{overbookingMessage}</> });
            setNewReservationInfo(null);
            handleCloseNewReservationPanel();
            return;
        }
        handleConfirmNewReservation(newReservationInfo);
        setNewReservationInfo(null);
    }, [
        canOverbook,
        handleCloseNewReservationPanel,
        handleConfirmNewReservation,
        loading,
        newReservationInfo,
        overbookingMessage,
    ]);

    return setNewReservationInfo;
};
